module.exports = __webpack_public_path__ + "corpo-leve-white.bf6f36e3c439209c1d45.png";


//////////////////
// WEBPACK FOOTER
// C:/xampp/htdocs/corpo-leve-www/www/src/assets/image/corpo-leve-white.png
// module id = ../../../../../src/assets/image/corpo-leve-white.png
// module chunks = main